import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  useAuthorization,
  useSubscription
} from '../uni-comms-api/hooks/authentication';
import PropTypes from 'prop-types';

export default function AuthorisationGate({
  children,
  permission,
  subscriptionPermissions = []
}) {
  const isAuthorized = useAuthorization(permission);
  const { hasPermission } = useSubscription();

  if (isAuthorized && subscriptionPermissions.every(p => hasPermission(p))) {
    return children;
  } else {
    return <Navigate to="/403" />;
  }
}

AuthorisationGate.propTypes = {
  children: PropTypes.node.isRequired,
  permission: PropTypes.string.isRequired
};
